import {format} from "date-fns";

export function timeAgo (time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

export function toCurPercent(value, isCurrency, isPercent, scale) {
  if ((!isCurrency && !isPercent) || isNaN(parseFloat(value))) {
    return value;
  }

  if (value && (typeof value === 'string' || value instanceof String)) {
    value = value.replace(/,|\$|\%/g, '')
  }

  if (isCurrency) {
    let fmtCur = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    return fmtCur.format(value);
  }

  if (isPercent) {
    if (value === null || value === undefined) {
      return 'N/A'
    }
    let fmtPct = new Intl.NumberFormat('en-US', {
      style: 'percent',
      minimumFractionDigits: 2,
      maximumFractionDigits: scale?? 2
    });
    return fmtPct.format(value / 100);
  }

  return value;
}

export function toCurDecimal (value, isCurrency, isDecimal) {
  if ((!isCurrency && !isDecimal) || isNaN(parseFloat(value))) {
    return value;
  }

  if (value && (typeof value === 'string' || value instanceof String)) {
    value = value.replace(/,|\$|\%/g, '')
  }

  if (isCurrency) {
    let fmtCur = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    return fmtCur.format(value);
  }

  if (isDecimal) {
    if (value === null || value === undefined) {
      return 'N/A'
    }
    let fmtDecimal = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2
    });
    return fmtDecimal.format(value);
  }

  return value;
}

export function toCurrency (value, isCurrency) {
  if (!isCurrency || isNaN(parseFloat(value))) {
    return value;
  }
  let formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
}

export function toPercent (value) {
  if (value === null || value === undefined) {
    return 'N/A'
  }
  if (isNaN(parseFloat(value))) {
    return value;
  }
  let formatter = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
}

export function toDate (value) {
  if (value === null || value === undefined) {
    return ''
  }
  return format(new Date(value), 'yyyy-MM-dd')
}

export function toDateTime (value) {
  if (value === null || value === undefined) {
    return ''
  }
  return format(new Date(value), 'yyyy-MM-dd HH:mm:ss')
}



